import React, { PureComponent } from 'react';
import { bool, func, shape, arrayOf, string } from 'prop-types';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';

import { message } from 'utils/stringUtils';
import { actionCreators as userFormActions, formResponsePropTypes } from 'redux/userFormHandlers';

import FormDetails from './layout';
import styles from './styles';

class FormDetailsContainer extends PureComponent {
  componentWillUnmount = () => this.props.dispatch(userFormActions.resetFormResponseDetails());

  render() {
    return (
      <div style={styles.container}>
        <FormDetails
          loading={this.props.loading}
          form={this.props.form}
          formDetails={this.props.formDetails}
          onReturn={this.props.onReturn}
          handleOpenActionModal={this.props.handleOpenActionModal}
        />
      </div>
    );
  }
}

FormDetailsContainer.propTypes = {
  handleOpenActionModal: func,
  loading: bool,
  onReturn: func,
  form: formResponsePropTypes,
  formDetails: arrayOf(
    shape({
      name: string.isRequired,
      value: string.isRequired
    })
  )
};

const detailsSelector = createSelector(
  (store, props) => store.userForm[`${props.form.form_type}FormResponses`],
  (store, props) => props.form,
  (formResponses, form) => {
    const formSearched = formResponses.find(formResponse => formResponse.id === form.id);
    if (formSearched) {
      const fields = [...formSearched.field_details];
      if (formSearched.field_details.completion_at)
        fields.push({
          name: message('FieldDetails:completionAt'),
          value: formSearched.field_details.completion_at
        });
      else if (formSearched.field_details.expected_completion_at)
        fields.push({
          name: message('FieldDetails:expectedCompletionAt'),
          value: formSearched.field_details.expected_completion_at
        });
      return fields;
    }
    return form.field_details;
  }
);

const mapStateToProps = (store, props) => ({
  formDetails: detailsSelector(store, props),
  loading: store.userForm.formDetailsLoading
});

export default connect(mapStateToProps)(FormDetailsContainer);
